export default "__VITE_ASSET__BZ91V7g8__"